var __jsx = React.createElement;
/** @format */

import React from 'react';
import MediaQuery from 'react-responsive';
import { responsiveQuery } from "../../../constants/css";
import { Icon } from "../../_global";
import { CardInfo, InfoBody, InfoHeader, InfoHeading } from "../../Offer/Card/style";
import { InfoButton, MobileInfo } from "../Style/index";
import { merchantProps } from "../Detail/merchantProps";
var TermsConditions = function TermsConditions(props) {
  var merchant = props.merchant,
    onClick = props.onClick,
    showTerms = props.showTerms;
  var renderTC = function renderTC() {
    var buildOffers = merchant && merchant.directOffers ? merchant.directOffers.map(function (v) {
      return __jsx("div", null, " ", v.terms, " ");
    }) : null;
    return __jsx("div", null, merchant && merchant.exclusions && __jsx("br", null), merchant && merchant.directOffers && buildOffers);
  };
  return __jsx("div", null, __jsx(MediaQuery, {
    query: responsiveQuery.mobile
  }, __jsx(MobileInfo, null, __jsx(InfoButton, {
    onClick: onClick
  }, "Terms & conditions"))), __jsx(CardInfo, {
    isVisible: showTerms
  }, __jsx(InfoHeader, null, __jsx("button", {
    onClick: onClick,
    "aria-label": "Close info"
  }, __jsx(Icon, {
    iconType: "closeCross",
    size: "base"
  })), __jsx(InfoHeading, null, "Terms & conditions")), __jsx(InfoBody, null, renderTC())));
};
TermsConditions.defaultProps = {
  merchant: null,
  onClick: function onClick() {},
  showTerms: false
};
export default /*#__PURE__*/React.memo(TermsConditions);